import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Shared password field with a show/hide (eye) toggle. Spreads all input props
// through and reserves right padding for the icon via inline style so it works
// regardless of the caller's className. The toggle testid is derived from the
// input's data-testid (e.g. "login-password" -> "login-password-toggle").
export const PasswordInput = ({ className = "", style = {}, wrapperClassName = "relative", "data-testid": testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className={wrapperClassName}>
      <input
        {...props}
        type={show ? "text" : "password"}
        data-testid={testId}
        className={className}
        style={{ ...style, paddingRight: 40 }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1 flex items-center justify-center"
        style={{ color: "var(--text-secondary)", background: "transparent" }}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

export default PasswordInput;
